import React from 'react';
import { Card } from 'react-bootstrap';
import { Accordion } from 'react-bootstrap';
import StatusArbitrageCoach from './statusArbitrageCoach';

function AffichageProchainMatch(props) {


    return (
        <>
        {props.equipe && (
            <>
                <Accordion defaultActiveKey="1">
                {props.equipe.ProchainMatch && props.equipe.ProchainMatch.map((item, index) => (
                        <Accordion.Item key={index}  eventKey={index}>
                                <Accordion.Header>
                                    <div className="text-center mb-3">
                                      {item.equipe_dom} {item.score === null ? ('-'):(item.score)} {item.equipe_ext}<br/> {item.date} <br/> {item.competition}
                                    </div>
                                  </Accordion.Header>
                            <Accordion.Body>
                                    <Card.Title><strong>Candidature :</strong><br/></Card.Title>
                                    {props.equipe.arbitre && props.equipe.arbitre.filter(items => items.id_match === item.id_match).length !== 0  ? (
                                        props.equipe.arbitre
                                            .filter(items => items.id_match === item.id_match)
                                            .map((Item, index) => (
                                                <div key={index} className="cards-container">
                                                    <StatusArbitrageCoach userData={props.userData} status={Item} match={item}/>
                                                </div>    
                                            ))
                                    ) : (
                                        <div className="text-center mb-3">
                                            <p>Aucune candidature pour ce match.</p>
                                        </div>
                                    )}
   
                        </Accordion.Body>
                    </Accordion.Item>
            ))}
            </Accordion><br/>
            </>
        )}

        </>
  );
}

export default AffichageProchainMatch;